import { render } from "./number-input.vue?vue&type=template&id=37453b26&scoped=true"
import script from "./number-input.vue?vue&type=script&lang=js"
export * from "./number-input.vue?vue&type=script&lang=js"

import "./number-input.vue?vue&type=style&index=0&id=37453b26&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37453b26"]])

export default __exports__